const INSERT_EMOJI_BUTTON = "insert-emoji-button";
const INSERT_EMOJI_MODAL = "insert-emoji-modal";
const INSERT_EMOJI_MODAL_LIST_ITEM = "insert-emoji-modal-list-item";
export {
  INSERT_EMOJI_BUTTON,
  INSERT_EMOJI_MODAL,
  INSERT_EMOJI_MODAL_LIST_ITEM
};
//# sourceMappingURL=data-hooks.js.map
